"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGrid = void 0;
var clsx_1 = __importDefault(require("clsx"));
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importStar(require("react"));
var react_data_grid_1 = __importStar(require("react-data-grid"));
var react_data_grid_addons_1 = require("react-data-grid-addons");
var Checkbox_1 = require("../Checkbox");
var Paper_1 = require("../Paper");
var styles_1 = require("../styles");
require("./DataGrid.css");
var DataGridHeadCell_1 = __importDefault(require("./DataGridHeadCell"));
var DataGridHeader_1 = __importDefault(require("./DataGridHeader"));
var helpers_1 = require("./helpers");
var testIdPrefix = 'DataGrid-';
var UnstyledDataGrid = /** @class */ (function (_super) {
    __extends(UnstyledDataGrid, _super);
    function UnstyledDataGrid() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            rowIdClicked: null,
        };
        _this.handleWidthChange = function (index, width) {
            var zeroIndex = index - 1;
            var _a = _this.props, columnData = _a.columnData, onWidthChange = _a.onWidthChange, columnMinWidth = _a.columnMinWidth;
            var newWidth = Math.max(width, columnMinWidth);
            var currentColumns = __spreadArray([], columnData, true);
            var columnToChange = currentColumns[zeroIndex];
            var changedColumn = __assign(__assign({}, columnToChange), { width: newWidth });
            currentColumns.splice(zeroIndex, 1, changedColumn);
            onWidthChange(currentColumns);
        };
        _this.onHeaderDrop = function (source, target) {
            var _a = _this.props, columnData = _a.columnData, onReorderColumn = _a.onReorderColumn;
            var columnSourceIndex = columnData.findIndex(function (i) { return i.id === source; });
            var columnTargetIndex = columnData.findIndex(function (i) { return i.id === target; });
            var reorderedColumnData = (0, helpers_1.reorderColumn)(columnData, columnSourceIndex, columnTargetIndex);
            onReorderColumn(reorderedColumnData);
        };
        _this.handleChangePage = function (_event, page) {
            var _a = _this.props, order = _a.order, orderBy = _a.orderBy, rowsPerPage = _a.rowsPerPage;
            var newRangeBottom = page * rowsPerPage + 1;
            var newRangeTop = newRangeBottom + (rowsPerPage - 1);
            // MUI pagination handles ranges that exceed the count, allowing us to keep this consistent
            if (_this.props.hasAllData) {
                _this.setState({
                    page: page,
                    rangeBottom: newRangeBottom,
                    rangeTop: newRangeTop,
                });
            }
            else {
                // TODO: This kind of setState side effect may not be ideal; could be an argument
                // for separating out the components.
                _this.props.updatePage({
                    rangeBottom: newRangeBottom,
                    rangeTop: newRangeTop,
                    order: order,
                    orderBy: orderBy,
                });
            }
        };
        _this.handleChangeRowsPerPage = function (event) {
            var _a = _this.props, hasAllData = _a.hasAllData, rangeBottom = _a.rangeBottom, updatePage = _a.updatePage, order = _a.order, orderBy = _a.orderBy;
            if (hasAllData) {
                updatePage({ rowsPerPage: event.target.value });
            }
            else {
                var newRangeBottom = (0, helpers_1.getNearestValidRangeBottom)(rangeBottom, event.target.value);
                updatePage({
                    rowsPerPage: event.target.value,
                    rangeBottom: newRangeBottom,
                    rangeTop: newRangeBottom + (event.target.value - 1),
                    order: order,
                    orderBy: orderBy,
                });
            }
        };
        _this.handleRequestSort = function (_event, property) {
            var orderBy = property;
            var order = 'desc';
            _this.setState(function (state) {
                if (state.orderBy === property && state.order === 'desc') {
                    order = 'asc';
                }
                if (_this.props.hasAllData) {
                    var data = (0, helpers_1.getSortedData)(state.data, orderBy, order);
                    return { data: data, orderBy: orderBy, order: order };
                }
                else {
                    // TODO: This kind of setState side effect may not be ideal; could be an argument
                    // for separating out the components.
                    var _a = _this.props, updatePage = _a.updatePage, rangeTop = _a.rangeTop, rangeBottom = _a.rangeBottom;
                    updatePage({
                        order: order,
                        orderBy: orderBy,
                        rangeTop: rangeTop,
                        rangeBottom: rangeBottom,
                    });
                }
            });
        };
        _this.createSortHandler = function (property) { return function (event) {
            _this.handleRequestSort(event, property);
        }; };
        _this.setSelected = function (selected) {
            _this.props.onSelect(selected);
        };
        _this.handleCheckboxClick = function (row) {
            var selected = _this.props.selected;
            var selectedIndex = selected.findIndex(function (_a) {
                var id = _a.id;
                return id === row.id;
            });
            var newSelected = [];
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, __assign({}, row));
            }
            else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            }
            else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            }
            else if (selectedIndex > 0) {
                newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
            }
            _this.setSelected(newSelected);
        };
        _this.isSelected = function (selectedId) {
            return _this.props.selected.some(function (_a) {
                var id = _a.id;
                return id === selectedId;
            });
        };
        _this.getCellActions = function (column, row) {
            if (column.key === '_checkbox') {
                var _a = _this.props, classes = _a.classes, data = _a.data, parentTestIdPrefix = _a.parentTestIdPrefix;
                var isSelected_1 = _this.isSelected(row.id);
                var index = data.findIndex(function (_a) {
                    var id = _a.id;
                    return id === row.id;
                });
                return [
                    {
                        icon: (react_1.default.createElement(Checkbox_1.Checkbox, { checked: isSelected_1, classes: { root: classes.checkboxRoot }, "data-testid": "".concat(parentTestIdPrefix).concat(testIdPrefix, "row-").concat(index + 1, "-checkbox"), onClick: function (e) {
                                e.stopPropagation();
                                _this.handleCheckboxClick(row, !isSelected_1);
                            } })),
                    },
                ];
            }
        };
        _this.onRowDoubleClick = function (i) {
            var data = _this.props.data;
            var row = data[i];
            if (!row) {
                return;
            }
            _this.setState(function (prevState) { return ({
                rowIdClicked: prevState.rowIdClicked === row.id ? null : row.id,
            }); });
            _this.props.onRowDoubleClick(row.id);
        };
        _this.toggleAll = function () {
            var _a = _this.props, selected = _a.selected, data = _a.data;
            var selectedShown = [];
            var unselectedShown = [];
            data.forEach(function (item) {
                _this.isSelected(item.id)
                    ? selectedShown.push(item)
                    : unselectedShown.push(item);
            });
            var shouldSelect = unselectedShown.length > 0;
            var newSelection = [];
            if (shouldSelect) {
                newSelection = __spreadArray(__spreadArray([], selected, true), unselectedShown, true);
            }
            else {
                selected.forEach(function (item) {
                    !selectedShown.some(function (_a) {
                        var id = _a.id;
                        return id === item.id;
                    }) &&
                        newSelection.push(item);
                });
            }
            _this.setSelected(newSelection);
        };
        return _this;
    }
    UnstyledDataGrid.getDerivedStateFromProps = function (nextProps, prevState) {
        var hasAllData = nextProps.hasAllData, data = nextProps.data, order = nextProps.order, orderBy = nextProps.orderBy, rangeBottom = nextProps.rangeBottom, rangeTop = nextProps.rangeTop;
        var currentPage = (0, helpers_1.getPage)(rangeTop, rangeBottom);
        // Prevent missing pagination props from causing silent failures
        var propError = !hasAllData && (0, helpers_1.checkPaginatedPropsError)(nextProps);
        return __assign(__assign({}, prevState), { order: order || 'asc', orderBy: orderBy, data: hasAllData ? (0, helpers_1.getSortedData)(data, orderBy, order) : data || [], page: currentPage || 0, error: propError });
    };
    UnstyledDataGrid.prototype.render = function () {
        var _this = this;
        var DraggableContainer = react_data_grid_addons_1.DraggableHeader.DraggableContainer;
        var _a = this.props, t = _a.t, classes = _a.classes, theme = _a.theme, count = _a.count, activeFiltersCount = _a.activeFiltersCount, tableHeight = _a.tableHeight, dropdownHandler = _a.dropdownHandler, filterHandler = _a.filterHandler, settingsHandler = _a.settingsHandler, data = _a.data, title = _a.title, subTitle = _a.subTitle, selectedOptions = _a.selectedOptions, columnData = _a.columnData, selected = _a.selected, emptyDisplay = _a.emptyDisplay, showActiveRowHighlight = _a.showActiveRowHighlight, downloadingCaption = _a.downloadingCaption, parentTestIdPrefix = _a.parentTestIdPrefix, rowsPerPageOptions = _a.rowsPerPageOptions, rowsPerPage = _a.rowsPerPage, order = _a.order, orderBy = _a.orderBy, usePageSelectPopover = _a.usePageSelectPopover;
        var page = this.state.page;
        var hasSelected = false;
        var hasUnselected = false;
        data.some(function (row) {
            var isSelected = _this.isSelected(row.id);
            hasSelected = hasSelected || isSelected;
            hasUnselected = hasUnselected || !isSelected;
            return hasSelected && hasUnselected;
        });
        var columns = columnData.map(function (_a) {
            var key = _a.key, id = _a.id, rest = __rest(_a, ["key", "id"]);
            return (__assign({ headerRenderer: function (props) { return (react_1.default.createElement(DataGridHeadCell_1.default, __assign({}, props, { testId: "".concat(parentTestIdPrefix).concat(testIdPrefix, "column-").concat(id) }))); }, 
                // sortable: true,
                resizable: true, draggable: true, active: orderBy === id, sortDirection: order, onClick: _this.createSortHandler(id), key: id, id: id }, rest));
        });
        columns = __spreadArray([
            {
                headerRenderer: function (props) {
                    var _a = props.column, allChecked = _a.allChecked, indeterminate = _a.indeterminate;
                    return (react_1.default.createElement("div", { className: classes.checkboxCell }, count > 0 && (react_1.default.createElement(Checkbox_1.Checkbox, { indeterminate: indeterminate, checked: allChecked, onChange: _this.toggleAll, className: classes.headerCellContent, "data-testid": "".concat(parentTestIdPrefix).concat(testIdPrefix, "selectAllCheckbox") }))));
                },
                key: '_checkbox',
                width: 42,
                frozen: true,
                allChecked: hasSelected && !hasUnselected,
                indeterminate: hasSelected && hasUnselected,
            }
        ], columns, true);
        var customRowRenderer = function (_a) {
            var renderBaseRow = _a.renderBaseRow, canvasProps = __rest(_a, ["renderBaseRow"]);
            var classes = _this.props.classes;
            var row = canvasProps.row, idx = canvasProps.idx;
            var extraClasses = classes.tableRow;
            if (showActiveRowHighlight && _this.state.rowIdClicked === row.id) {
                extraClasses = (0, clsx_1.default)(extraClasses, classes.tableRowActive);
            }
            else if (_this.isSelected(row.id)) {
                extraClasses = (0, clsx_1.default)(extraClasses, classes.tableRowSelected);
            }
            else {
                extraClasses = (0, clsx_1.default)(extraClasses, classes.tableRowDefaultColor);
            }
            // this overrides the undesired default behavior of react-data-grid
            var onDragOver = function (e) {
                e.preventDefault();
                e.dataTransfer.dropEffect = 'none';
            };
            // each rows border takes up 1px of height, so the cells themselves need to take that into account
            var cellRenderer = (0, react_1.forwardRef)(function (props, ref) { return (react_1.default.createElement(react_data_grid_1.Cell, __assign({ ref: ref }, props, { height: _this.props.theme.spacing(4) - 1 }))); });
            cellRenderer.displayName = 'CellRenderer';
            return (react_1.default.createElement("div", { onDragOver: onDragOver, "data-testid": "".concat(parentTestIdPrefix).concat(testIdPrefix, "row-").concat(idx + 1) }, renderBaseRow(__assign(__assign({}, canvasProps), { extraClasses: extraClasses, cellRenderer: cellRenderer }))));
        };
        return (react_1.default.createElement(Paper_1.Paper, { elevation: 2, className: classes.root },
            react_1.default.createElement("div", { className: classes.tableWrapper },
                react_1.default.createElement(DraggableContainer, { onHeaderDrop: this.onHeaderDrop },
                    react_1.default.createElement(react_data_grid_1.default, { className: classes.table, columns: columns, rowGetter: function (i) { return data[i]; }, rowsCount: data.length, minHeight: tableHeight, headerRowHeight: theme.spacing(4.5), rowRenderer: customRowRenderer, getCellActions: this.getCellActions, onColumnResize: this.handleWidthChange, onRowDoubleClick: this.onRowDoubleClick, emptyRowsView: function () { return emptyDisplay; }, rowHeight: theme.spacing(4), toolbar: function () { return (react_1.default.createElement(DataGridHeader_1.default, { t: t, title: title, subTitle: subTitle, count: count, activeFiltersCount: activeFiltersCount, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions, page: page, handleChangePage: _this.handleChangePage, handleChangeRowsPerPage: _this.handleChangeRowsPerPage, dropdownHandler: dropdownHandler, selectedOptions: selectedOptions, settingsHandler: settingsHandler, filterHandler: filterHandler, selected: selected, downloadingCaption: downloadingCaption, parentTestIdPrefix: parentTestIdPrefix, usePageSelectPopover: usePageSelectPopover })); } })))));
    };
    UnstyledDataGrid.propTypes = {
        theme: prop_types_1.default.object.isRequired,
        emptyDisplay: prop_types_1.default.any,
        column: prop_types_1.default.any,
        updatePage: prop_types_1.default.func,
        rangeBottom: prop_types_1.default.number,
        rangeTop: prop_types_1.default.number,
        t: prop_types_1.default.func.isRequired,
        classes: prop_types_1.default.object.isRequired,
        activeFiltersCount: prop_types_1.default.number,
        count: prop_types_1.default.number,
        tableHeight: prop_types_1.default.number,
        dropdownHandler: prop_types_1.default.func,
        filterHandler: prop_types_1.default.func,
        settingsHandler: prop_types_1.default.func,
        onWidthChange: prop_types_1.default.func,
        columnMinWidth: prop_types_1.default.number,
        data: prop_types_1.default.arrayOf(prop_types_1.default.shape({ id: prop_types_1.default.number })),
        hasAllData: prop_types_1.default.bool,
        title: prop_types_1.default.string,
        subTitle: prop_types_1.default.string,
        selectedOptions: prop_types_1.default.node.isRequired,
        columnData: prop_types_1.default.arrayOf(prop_types_1.default.shape({})).isRequired,
        selected: prop_types_1.default.arrayOf(prop_types_1.default.shape({})),
        showActiveRowHighlight: prop_types_1.default.bool,
        downloadingCaption: prop_types_1.default.string,
        parentTestIdPrefix: prop_types_1.default.string,
        rowsPerPageOptions: prop_types_1.default.arrayOf(prop_types_1.default.number),
        rowsPerPage: prop_types_1.default.number,
        order: prop_types_1.default.string,
        orderBy: prop_types_1.default.string,
        onSelect: prop_types_1.default.func,
        onRowDoubleClick: prop_types_1.default.func,
        onReorderColumn: prop_types_1.default.func,
        usePageSelectPopover: prop_types_1.default.bool,
    };
    UnstyledDataGrid.defaultProps = {
        columnData: [],
        onSelect: function () { },
        onRowDoubleClick: function () { },
        onReorderColumn: function () { },
        onWidthChange: function () { },
        selectable: true,
        selected: [],
        showActiveRowHighlight: false,
        downloadingCaption: false,
        parentTestIdPrefix: '',
        columnMinWidth: 80,
        activeFiltersCount: 0,
        usePageSelectPopover: true,
    };
    return UnstyledDataGrid;
}(react_1.Component));
var styles = function (theme) { return ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
        overflow: 'auto',
        fontFamily: theme.typography.fontFamily,
    },
    tableWrapper: {
        backgroundColor: theme.palette.primary.main,
    },
    table: {
        borderTop: 'solid 1px',
        borderTopColor: theme.palette.grey[900],
    },
    tableRow: __assign(__assign({}, theme.typography.body2), { padding: 0, boxSizing: 'border-box', borderBottom: 'solid 1px', borderBottomColor: theme.palette.grey[300] }),
    tableRowDefaultColor: {
        backgroundColor: theme.palette.common.white,
        '&:hover': {
            backgroundColor: theme.palette.grey[100],
        },
    },
    tableRowActive: {
        backgroundColor: theme.palette.color.lightBlue[200],
        '&:hover': {
            backgroundColor: theme.palette.color.lightBlue[300],
        },
    },
    tableRowSelected: {
        backgroundColor: theme.palette.color.lightBlue[100],
    },
    headerCellContent: {
        color: theme.palette.primary.contrastText,
        padding: 0,
    },
    checkboxRoot: {
        padding: '0 0 0 6px',
    },
    checkboxCell: {
        padding: 6,
        textAlign: 'center',
        height: '100%',
        backgroundColor: theme.palette.primary.main,
        overflow: 'none',
        border: 'none',
    },
}); };
/** @deprecated Will be removed in a future major release */
exports.DataGrid = (0, styles_1.withStyles)(styles, { withTheme: true })(UnstyledDataGrid);
exports.default = exports.DataGrid;
//# sourceMappingURL=index.js.map